/* eslint-disable max-lines */
/* eslint-disable max-lines */
import { POST_FIELDS } from '@/services/charts-service';
import {
  DEFAULT_SIZES,
  DATA_TYPE,
  COMPONENT_TYPE,
  FILTER_NAMES,
  WIDTH,
  HEIGHT,
} from '@/store/modules/cards/constants';
import { Flags } from '@/plugins/rollout';
/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'PNP_1',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'OwnedEarnedPostReach',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Total de publicações Owned e Earned',
      originalTitle: 'Total de publicações Owned e Earned',
      isExpandedCard: false,
      description: 'Somatório de publicações proprietárias e não proprietárias coletadas na pesquisa.',
    },
  },
  {
    id: 'PNP_2',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByTag',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Alcance Sentimento por Tag Owned + Earned',
      originalTitle: 'Alcance Sentimento por Tag Owned + Earned',
      isExpandedCard: false,
      description: 'soma do alcance e distribuição de publicações proprietárias e não proprietárias pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'PNP_3',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByTerms',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Sentimento por termo Owned + Earned',
      originalTitle: 'Sentimento por termo Owned + Earned',
      isExpandedCard: false,
      description: 'soma da distribuição de publicações proprietárias e não proprietárias  por termos mais mencionados e sua divisão de polaridade.',
      tags: 'Termos; Sentimento',
    },
  },
  {
    id: 'PNP_4',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByThemes',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Sentimento por tema Owned + Earned',
      originalTitle: 'Sentimento por tema Owned + Earned',
      isExpandedCard: false,
      description: 'Soma da distribuição de publicações proprietárias e não proprietárias pelos Temas cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
      tags: 'Sentimento, Categorias e Anotações',
    },
  },
  {
    id: 'PNP_5',
    width: WIDTH.SMALL,
    height: HEIGHT.SMALL,
    component: 'BrandHealthOwnedEarned',
    componentType: COMPONENT_TYPE.GAUGE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Saúde da marca Owned + Earned',
      originalTitle: 'Saúde da marca Owned + Earned',
      isExpandedCard: false,
      description: 'Representa, em forma de gauge, o resultado da equação: (publicações proprietárias e não proprietárias positivas / publicações proprietárias e não proprietárias coletadas * 100) - (publicações proprietárias e não proprietárias negativas / publicações proprietárias e não proprietárias coletadas * 100).',
      tags: 'Sentimento',
    },
  },
  {
    id: 'PNP_6',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'BaseChannelPieChartOwnedEarned',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Distribuição por Canal Owned + Earned',
      originalTitle: 'Distribuição por Canal Owned + Earned',
      isExpandedCard: false,
      description: 'Divisão das publicações por canal de coleta proprietárias e não proprietárias.',
      tags: 'Demográficos',
    },
  },
  {
    id: 'PNP_7',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'OwnedEarnedCollectedUsers',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Total de usuários para Owned e Earned',
      originalTitle: 'Total de usuários para Owned e Earned',
      isExpandedCard: false,
      description: 'Contagem de usuários únicos que geraram o total de publicações proprietárias e não-proprietárias na pesquisa.',
    },
  },
  {
    id: 'PNP_8',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'OwnedEarnedPotentialReach',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Alcance Potencial para Owned e Earned',
      originalTitle: 'Alcance Potencial para Owned e Earned',
      isExpandedCard: false,
      description: 'Representa 20% da somatória de seguidores/inscritos dos perfis coletados na pesquisa para publicações proprietárias e não proprietárias.',
    },
  },
  {
    id: 'PNP_9',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'TagSharePieChartOwnedEarned',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showPNPTagsShare, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Publicações por tag para Owned e Earned',
      originalTitle: 'Publicações por tag para Owned e Earned',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelas tags atribuídas para Owned e Earned',
      selectedFilters: [FILTER_NAMES.TAGS_VIEW],
    },
  },
  {
    id: 'PNP_10',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'OwnedEarnedUniquePostReach',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Total de publicações únicas Owned e Earned',
      originalTitle: 'Total de publicações únicas Owned e Earned',
      isExpandedCard: false,
      description: 'Somatório de publicações únicas proprietárias e não proprietárias coletadas na pesquisa.',
    },
  },
  {
    id: 'PNP_11',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'SentimenTimeSeriesSacListening',
    componentType: COMPONENT_TYPE.STACKED_AREA,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSentimentInTimePNP, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Sentimento no tempo para publicações e interações',
      originalTitle: 'Sentimento no tempo para publicações e interações',
      isExpandedCard: false,
      description: 'Distribuição da somatória de publicações e interações recebidas por sua polaridade ao longo de um período de tempo..',
    },
  },
  {
    id: 'PNP_12',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeriesSacListening',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showTagInTimePNP, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Publicações por Tag no Tempo',
      originalTitle: 'Publicações por Tag no Tempo',
      isExpandedCard: false,
      description: 'Distribuição do somatório de publicações proprietárias e não proprietárias pelas Tags atribuídas na pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'PNP_13',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'SumPostsAndInteractionsInTime',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showPostAndInteractionsIntime, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Publicações no tempo',
      originalTitle: 'Publicações no tempo',
      isExpandedCard: false,
      description: 'Distribuição linear da soma de publicações e interações de Listening + Métricas Proprietárias coletadas ao longo de um período de tempo.',
    },
  },
  {
    id: 'PNP_14',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'SentimentPieChartPNP',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showPolarityPieChartPNP, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Distribuição por Sentimento',
      originalTitle: 'Distribuição por Sentimento',
      isExpandedCard: false,
      description: 'Soma de publicações e interações (Listening + Métricas Proprietárias) divididas por polaridade positiva, negativa ou neutra.',
      tags: 'Sentimento',
    },
  },
  {
    id: 'PNP_15',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PostSamplingProjectionSacListening',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showPostSamplingProjectionPNP, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Projeção amostragem de publicações',
      originalTitle: 'Projeção amostragem de publicações',
      isExpandedCard: false,
      description: 'Projeção de publicações amostradas para Listening + Métricas Proprietárias.',
    },
  },
  {
    id: 'PNP_16',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'TotalPostsSharesAndComments',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showTotalPostsSharesAndComments, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Total de publicações, compartilhamentos e comentários',
      originalTitle: 'Total de publicações, compartilhamentos e comentários',
      isExpandedCard: false,
      description: 'Somatório de publicações proprietárias e não proprietárias, compartilhamentos e comentários.',
    },
  },
  {
    id: 'PNP_17',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'TotalPostsSharesAndCommentsInTime',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showTotalPostsSharesAndCommentsInTime, Flags.showStudioDev, Flags.showStudioPlus],
    props: {
      title: 'Total de publicações, compartilhamentos e comentários no Tempo',
      originalTitle: 'Total de publicações, compartilhamentos e comentários no Tempo',
      isExpandedCard: false,
      description: 'Distribuição do somatório de publicações proprietárias e não proprietárias, compartilhamentos e comentários ao longo do tempo.',
    },
  },
];
